import referralCodesTypes from "./referralCodesTypes";
import referralCodesApi from "./referralCodesApi";

const referralCodesActions = {
    getReferralCodes: (branch_id, params) => async dispatch => {
        dispatch({ type: referralCodesTypes.GET_REFERRAL_CODES_PENDING });
        try {
            const data = await referralCodesApi.listReferralCodes(branch_id, params);
            dispatch({ type: referralCodesTypes.GET_REFERRAL_CODES_SUCCESS, payload: data });
        } catch (e) {
            dispatch({ type: referralCodesTypes.GET_REFERRAL_CODES_ERROR });
        }
    },
    setParams: (params) => ({
        type: referralCodesTypes.SET_REFERRAL_CODES_PARAMS,
        payload: params,
    }),
    reset: () => ({ type: referralCodesTypes.RESET_REFERRAL_CODES }),
}

export default referralCodesActions;
